module.exports = __webpack_public_path__ + "img/0bfb0381-4be5-4803-b004-378819c9996a.e61c15ca.png";